// src/redux/reducers/role-management/role/roleReducer.js
import {
  CREATE_ROLE_REQUEST,
  CREATE_ROLE_SUCCESS,
  CREATE_ROLE_FAILURE,
  FETCH_ROLES_REQUEST,
  FETCH_ROLES_SUCCESS,
  FETCH_ROLES_FAILURE,
} from "../../../actions/role-management/role/roleActions";

const initialState = {
  loading: false,
  roles: [],
  error: null,
};

const roleReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_ROLE_REQUEST:
    case FETCH_ROLES_REQUEST:
      return { ...state, loading: true, error: null };

    case CREATE_ROLE_SUCCESS:
      return { ...state, loading: false, error: null };

    case FETCH_ROLES_SUCCESS:
      return { ...state, loading: false, roles: action.payload, error: null };

    case CREATE_ROLE_FAILURE:
    case FETCH_ROLES_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default roleReducer;
